import { CSSObject } from "@emotion/react";

import ArticleBody from "@/view/ContentDisplay/ArticleBody";
import ContentDisplayHeaderMedia from "@/view/ContentDisplay/ContentDisplayHeaderMedia";
import ContentDisplayTitle from "@/view/ContentDisplay/ContentDisplayTitle";
import { articleTitleContainerCss } from "./ArticlePreview.styles";

import type { Article } from "@/types/models";
import type ContentLevel from "@/types/models/ContentLevel.interface";
import type { ContentType } from "@/view/constants/contentTypes";

interface ArticlePreviewProps {
  content: {
    id: string;
    data: Article;
    content_type: ContentType;
  };
  contentMetadata?: any;
  currentLevel?: ContentLevel | undefined;
  styleOverrides?: {
    title?: CSSObject;
    titleWrapper?: CSSObject;
    mediaWrapper?: CSSObject;
    contentWrapper?: CSSObject;
  };
}

const ArticlePreview = ({
  content,
  contentMetadata,
  currentLevel,
  styleOverrides,
}: ArticlePreviewProps) => {
  return (
    <>
      <div css={[articleTitleContainerCss, styleOverrides?.titleWrapper]}>
        <ContentDisplayTitle
          currentLevel={currentLevel}
          title={currentLevel?.title}
          styleOverrides={styleOverrides?.title}
        />
      </div>
      {currentLevel && (
        <ContentDisplayHeaderMedia
          contentData={content?.data}
          currentLevel={currentLevel}
          styleOverrides={styleOverrides?.mediaWrapper}
        />
      )}
      <div css={styleOverrides?.contentWrapper}>
        <ArticleBody
          content={content}
          contentMetadata={contentMetadata}
          isPreview
          language={currentLevel?.language}
          levelId={currentLevel?.id || ""}
          lexile={`${currentLevel?.lexile || ""}`}
          rawText={currentLevel?.raw_text}
        />
      </div>
    </>
  );
};

export default ArticlePreview;
